import { nanoid } from 'nanoid';
import styled from 'styled-components';

const HighlightedText = styled.span`
  background-color: #fbfb52;
`;

export const highlightText = (text: string, highlight: string) => {
  if (!text) {
    return '';
  }
  if (!highlight) {
    return text;
  }
  const regex = new RegExp(`(${highlight})`, 'gi');
  return text
    .split(regex)
    .map((part) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <HighlightedText key={nanoid()}>{part}</HighlightedText>
      ) : (
        part
      ),
    );
};
